// 环境判断函数
export const getEnvPrefix = () => {
  // 开发环境可以通过环境变量指定使用哪个环境的API
  if (
    import.meta.env.MODE === "dev" ||
    window.location.href.indexOf("localhost") !== -1
  ) {
    // 可以根据需要返回开发环境使用的前缀，默认使用pre环境
    return import.meta.env.VITE_API_ENV || "test-";
  }

  // 预发布环境
  if (window.location.href.indexOf("pre-") !== -1) {
    return "pre-";
  }

  // 测试环境
  if (window.location.href.indexOf("test-") !== -1) {
    return "test-";
  }

  // 生产环境，无前缀
  return "";
};

// 根据环境生成URL
const generateURL = (baseDomain: string) => {
  const prefix = getEnvPrefix();
  // 从基础域名中提取协议和域名部分
  const domainParts = baseDomain.split("//");
  // return prefix == "test-"
  //   ? `${domainParts[0]}//hb2-test${domainParts[1].split("www")[1]}`
  //   : `${domainParts[0]}//${prefix}${domainParts[1]}`;
  return `${domainParts[0]}//${prefix}${domainParts[1]}`;
  // return `http://${prefix}${domainParts[1]}`;
};

// 服务基础域名配置
const domains = {
  apiCboWebBaseURL: "//www.partnermarketing.cn",
  apiCboAdsurl: "//www.partnermarketing.cn",
};

export default {
  apiCboWeb: generateURL(domains.apiCboWebBaseURL),
  apiCboAds: generateURL(domains.apiCboAdsurl),
  fileUrl:
    generateURL(domains.apiCboAdsurl) +
    "/cbo-merchant-ads/base/file/getTxTmpSecretInfo",
};
